// extracted by mini-css-extract-plugin
module.exports = {"subscribe_wrapper":"Subscribe_subscribe_wrapper__UU5PB","discount":"Subscribe_discount__e5Jap","message":"Subscribe_message__8BGSJ","btn-group":"Subscribe_btn-group__22jfv"};